var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.217,
    height: 12.326,
    viewBox: "0 0 9.217 12.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sort_1_",
    "data-name": "sort (1)",
    transform: "translate(0 0)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M218.32,2.206,216.266.152h0q-.018-.018-.037-.034L216.21.1l-.022-.016-.022-.014-.021-.012-.023-.011L216.1.041l-.023-.008-.024-.009-.023-.006L216,.011l-.027,0-.022,0a.517.517,0,0,0-.1,0l-.022,0-.027,0-.025.006-.023.006-.024.009-.023.008-.022.01-.023.011-.021.012-.022.014L215.6.1l-.018.014c-.013.011-.026.022-.037.034h0l-2.054,2.054a.514.514,0,1,0,.726.726l1.178-1.178v5.95a.514.514,0,1,0,1.027,0V1.755l1.178,1.178a.514.514,0,1,0,.726-.726Z",
    transform: "translate(-209.253 -0.001)",
    fill: "#003c7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M89.593,175.953l-1.178,1.178v-5.95a.514.514,0,1,0-1.027,0v5.95l-1.178-1.178a.514.514,0,0,0-.726.726l2.054,2.054h0c.012.012.024.023.037.034l.018.014.022.016.022.014.021.012.023.011.022.01.023.008.024.009.023.006.025.006.027,0,.022,0a.516.516,0,0,0,.1,0l.022,0,.027,0,.025-.006.023-.006.024-.009.023-.008.022-.01.023-.011.021-.012.022-.014.022-.016.018-.014c.013-.011.025-.022.037-.034h0l2.054-2.054a.514.514,0,1,0-.726-.726Z",
    transform: "translate(-85.334 -166.558)",
    fill: "#003c7d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.e5eccfb89c9ccf3aeba42c0547ccaaa4.svg";
export { ForwardRef as ReactComponent };